import { FormControl, Select } from "@primer/react";
import { useAppTheme } from "../AppTheme/AppTheme.jsx";
import "./ThemePicker.css";

export function ThemePicker() {
  const { appearance, setAppearance } = useAppTheme();

  return (
    <FormControl className="theme-picker">
      <FormControl.Label>Theme</FormControl.Label>
      <Select block value={appearance} onChange={(event) => setAppearance(event.target.value)} aria-label="Theme">
        <Select.Option value="system">System</Select.Option>
        <Select.Option value="light">Light</Select.Option>
        <Select.Option value="dark">Dark</Select.Option>
      </Select>
    </FormControl>
  );
}
